var toggleButton = $('.js-toggle-cookie-details');
var toggleButtonText = toggleButton.find('.js-cookies-details-text');
var cookieDetails = $('.js-cookie-details');
var cookieSubmit = $('.js-cookie-submit[disabled]');
var cookieToggle = $('.js-toggle-cookie-panel');
var cookieReject = $('.js-cookie-reject');
var cookieAll = $('.js-cookie-all');
var cookieForm = $('.js-cookie-form');

var params = {
    showText: toggleButtonText.data('show-text'),
    hideText: toggleButtonText.data('hide-text'),
};

$(window).on('load', function() {
    if (cookieSubmit.length) {
        cookieSubmit.removeAttr('disabled')
    }
});

toggleButton.on('click', function() {
    if (toggleButton.hasClass('cookies__button--rotate-icon js-toggle-cookie-details-active')) {
        toggleButton.removeClass('cookies__button--rotate-icon js-toggle-cookie-details-active');
        toggleButtonText.text(params.showText);
        cookieDetails.slideUp(300, 'easeInOutQuad');
    }
    else {
        toggleButton.addClass('cookies__button--rotate-icon js-toggle-cookie-details-active');
        toggleButtonText.text(params.hideText);
        cookieDetails.slideDown(300, 'easeInOutQuad');
    }
});

cookieToggle.on('click', function() {
    $('.js-cookies-overlay').fadeIn(300);
    $('.js-cookies').fadeIn(300);
    $(this).addClass('cookies__show-panel--hidden');
});

cookieReject.on('click', function() {
    $(this).addClass('button--loading').prop('disabled', true);
    $('.js-cookie-cb:not([disabled])').prop('checked', false);
    cookieForm.submit();
});

cookieAll.on('click', function() {
    $(this).addClass('button--loading').prop('disabled', true);
    $('.js-cookie-cb:not([disabled])').prop('checked', true);
    cookieForm.submit();
});
